<template>
  <div class="bracket-header-round">Этап {{ roundDescription }}</div>
</template>

<script>
const roundDescriptions = {
  "0": "Финал",
  "1": "Полуфинал",
  "2": "Четвертьфинал"
};

export default {
  name: "BracketHeader",
  props: {
    round: {
      required: true
    }
  },
  computed: {
    roundDescription() {
      return roundDescriptions[this.round] || "1/" + Math.pow(2, this.round);
    }
  }
};
</script>

<style lang="scss">
.bracket-header-round {
  position: relative;
  border-bottom: 4px solid colors(palette-4);
  width: 190px;
  color: colors(text-2);
  font-size: 18px;
  font-weight: fw(bold);
  padding-bottom: 5px;
  margin-right: 30px;

  @include breakpoint("xl-only") {
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
